import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const installSteps = css`
  padding: ${size[64]} 0;
  margin-bottom: ${size[64]};
  position: relative;

  ${breakpoint.up('smMd')} {
    padding: ${size[128]} 0;
  }
`

export const container = css`
  margin: 0 auto;
  padding: 0 ${size[20]};
  max-width: ${width.container.large};
`

export const headline = (theme: Theme) => css`
  max-width: 20em;
  margin: 0 auto;
  text-align: center;
  position: relative;
  font-size: 32px;
  font-weight: 600;
  line-height: inherit;
  color: ${theme.palette.text.title};

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
    letter-spacing: -1px;
  }
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`

export const steps = css`
  display: grid;
  grid-gap: ${size[48]};
  margin-top: ${size[40]};

  ${breakpoint.up('lg')} {
    grid-gap: ${size[48]};
  }

  ${breakpoint.up('smMd')} {
    margin-top: ${size[64]};
    grid-gap: ${size[32]};
    grid-template-columns: repeat(3, minmax(10rem, 23rem));
    justify-content: space-between;
    align-items: start;
  }
`
